import React, {useState, useEffect} from 'react';
import { UiContext } from '../contexts/UiContext';
import { useNavigate } from 'react-router-dom';
import { ManagerContext } from '../contexts/ManagerContext';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import PhoneIcon from '@mui/icons-material/Phone';
import FavoriteIcon from '@mui/icons-material/Favorite';
import PersonPinIcon from '@mui/icons-material/PersonPin';
import PhoneMissedIcon from '@mui/icons-material/PhoneMissed';

import { 
    HomeRounded,
    ContactPage,
    VolunteerActivism } from '@mui/icons-material';


export default function MenuTop() {
  const { setOpenContact } = React.useContext(UiContext)
  const [value, setValue] = React.useState(0);
  const { display, currentPage, currentUser } = React.useContext(ManagerContext);
  const navigate = useNavigate();

  const handleChange = (event, newValue) => {
    if(newValue !==2 ) setValue(newValue);
    if(newValue===0){
      navigate('/')
    }else if(newValue===1){
      navigate('/donate')
    }else if(newValue===2){
      setOpenContact(true)
    }else if(newValue===3){
      navigate('/admin123456789')
    }
  };

  useEffect(() => {
    setValue(currentPage)
  }, [currentPage])
  console.log('curentuser', currentUser)
  return (
    <Tabs
      value={value}
      onChange={handleChange}
      aria-label="icon position tabs example"
      centered
    >
      <Tab icon={<HomeRounded />} iconPosition="start" label={display()>2 || display()===null?'Chat':''} />
      <Tab icon={<VolunteerActivism />} iconPosition="start" label={display()>2 || display()===null?'Donate':''} />
      <Tab icon={<ContactPage />} iconPosition="start" label={display()>2 || display()===null?'Contact':''} />
      {currentUser && currentUser.level >= 10 &&<Tab icon={<AdminPanelSettingsIcon />} iconPosition="start" label={display()>2 || display()===null?'Admin':''} />}

    </Tabs>
  );
}
